module.exports = __webpack_public_path__ + "images/b5a1a4a005e4eb02a2ef867d2c6a9054.webp";